import styled from 'styled-components';
import React from 'react';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { breakpoints } from '@/components/responsive';

export interface StrapiReviewCardProps {
  text: string;
  href: string;
  image: string;
  store: string;
  author?: string;
  job?: string;
}

export function StrapiReviewCard({
  text,
  href,
  image,
  store,
}: StrapiReviewCardProps) {
  return (
    <Wrapper>
      <StrapiTextual
        text={text}
        weight="light"
        size="1.6rem"
        mobileMultiplier={0.9}
      />
      <Footer>
        <img src={image} alt="" />
        <span>
          5/5 rating from {` `}
          <StrapiTextual
            text={store}
            href={href}
            size="1.4rem"
            style={{ color: `#7F8B96`, textDecoration: `underline` }}
          />
        </span>
      </Footer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: 1fr 5rem;
  padding: 2rem;
  border: 1px solid rgba(151, 151, 151, 0.1);
  border-radius: 1rem;
  background-color: white;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.23),
    0 4px 6px 0 rgba(177, 217, 203, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.03);

  ${breakpoints.down(`md`)} {
    width: 80vw !important;
  }

  & > * {
    text-align: start;
    line-height: 1.7;
    letter-spacing: -0.5px;
  }

  span {
    font-size: 1.3rem;
    color: #7f8b96;
    font-family: Eesti, serif;
  }

  img {
    height: 3.5rem;
    width: auto;
    border-radius: 50%;
    object-fit: contain;
  }
`;

const Footer = styled.div`
  border-top: 1px solid rgba(151, 151, 151, 0.29);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 1rem;
  align-items: center;
  padding-top: 1rem;
  margin-top: 1rem;
`;
